import React from 'react';

function Services() {
  return (
    <section id="services-section" className="section-padding">
      <div className="container">
        <h2>Autonomous Agentic Capabilities. Architected for Enterprise Complexity.</h2>
        <div className="services-grid">
          
          {/* Service 1 */}
          <div className="service-card">
            <div className="card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
                <path d="M12 6v6l4 2" />
                <path d="M16.24 7.76a6 6 0 1 0 0 8.49" />
              </svg>
            </div>
            <h3>Cognitive Agent Architectures</h3>
            <p>
              We design and implement custom single and multi-agent systems driven by advanced reasoning loops. By establishing clear goals, prompt chains, and self-reflection patterns, our agents navigate complex business workflows with unprecedented cognitive depth.
            </p>
            <span className="gcp-oci-note">Leveraging <span className="gcp-text">Agent Platform</span> & <span className="oracle-text">Oracle Analytics Cloud</span>.</span>
          </div>

          {/* Service 2 */}
          <div className="service-card">
            <div className="card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect width="16" height="16" x="4" y="4" rx="2" />
                <rect width="6" height="6" x="9" y="9" rx="1" />
                <path d="M9 1v3" />
                <path d="M15 1v3" />
                <path d="M9 20v3" />
                <path d="M15 20v3" />
                <path d="M20 9h3" />
                <path d="M20 15h3" />
                <path d="M1 9h3" />
                <path d="M1 15h3" />
              </svg>
            </div>
            <h3>Tool Use & Custom API Integration</h3>
            <p>
              We equip agents with the ability to act. Through secure tool-use definitions, agents programmatically interface with enterprise databases, query web APIs, interact with internal legacy systems, and execute complex filesystems tasks safely.
            </p>
            <span className="gcp-oci-note">Utilizing <span className="gcp-text">Agent Platform</span>, <span className="gcp-text">BigQuery ML</span> & <span className="oracle-text">OCI AI Services</span>.</span>
          </div>

          {/* Service 3 */}
          <div className="service-card">
            <div className="card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 13c0 5-3.5 7.5-7.66 9.7a1 1 0 0 1-.68 0C7.5 20.5 4 18 4 13V6a1 1 0 0 1 .76-.97l8-2a1 1 0 0 1 .48 0l8 2A1 1 0 0 1 20 6v7z" />
                <line x1="12" x2="12" y1="9" y2="13" />
                <line x1="12" x2="12.01" y1="17" y2="17" />
              </svg>
            </div>
            <h3>Human-in-the-Loop Governance</h3>
            <p>
              Safety and security are built-in. We architect robust governance control planes that insert human approval gates for critical actions (e.g., executing transactions, writing to production schemas) and implement guardrails against prompt injection and memory leakage.
            </p>
            <span className="gcp-oci-note">Supported by <span className="gcp-text">GCP IAM</span> & <span className="oracle-text">OCI Security Rules</span>.</span>
          </div>

          {/* Service 4 */}
          <div className="service-card">
            <div className="card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
              </svg>
            </div>
            <h3>MLOps & Trajectory Telemetry</h3>
            <p>
              Ensure peak agent performance. We implement comprehensive telemetry pipelines that track agent execution steps, trace planning trajectories, analyze token expenditures, optimize LLM context usage, and manage prompt deployments continuously.
            </p>
            <span className="gcp-oci-note">Emphasis on <span className="gcp-text">Agent Platform</span>, <span className="gcp-text">Agent Platform</span> & <span className="oracle-text">OCI APM</span>.</span>
          </div>

        </div>

        <div className="platform-highlight">
          <h3>Dual-Cloud Excellence: Deploying Agents on GCP & Oracle OCI</h3>
          <p>
            Savage Technologies builds hybrid and multi-cloud architectures that combine the strengths of the industry's two most powerful cloudWe design state-of-the-art cognitive layers using Google Cloud's AI suite. Leveraging <strong>Agent Platform</strong> and foundational <strong>Gemini models</strong>, we architect agents with advanced semantic understanding, multimodal reasoning, and rapid MLOps pipelines.rototyping. Simultaneously, we anchor agent execution in **Oracle Cloud Infrastructure (OCI)** to secure transactional data systems, execute high-volume database vector searches, and guarantee enterprise-grade data security with autonomous recovery.
          </p>
          <div className="platform-logos">
            {/* Google Cloud SVG */}
            <svg viewBox="0 0 24 24" style={{ height: '40px' }} fill="currentColor">
              <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3z" />
            </svg>
            {/* Oracle OCI SVG (stylized) */}
            <svg viewBox="0 0 24 24" style={{ height: '40px' }} fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-4-9h8v2H8z" />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
